import { all, put, select, takeLatest } from 'redux-saga/effects';
import { AlertActionType } from '@store/alert/alert-action';
import { ProductsActionTypes } from './products-actions';
import getProductDatatableApi from '@api/shop/get-product-datatable';
import { productsStore } from './products-store';

function* getProductsListWatcher() {
  const { sort, productFilter, productPagination } = yield select(productsStore);
  try {
    const productListResponse: { data: Array<any>, last_page: string, current_page: string, per_page: string, total: string } = yield getProductDatatableApi({
      page: productPagination.page,
      sort: sort,
      title: productFilter.title,
      categoryIds: productFilter.category,
      brandIds: productFilter.brand,
      cache: 'no-cache',
    });

    yield put({
      type: ProductsActionTypes.SET_PRODUCT_LIST,
      data: {
        productList: productListResponse?.data,
        pagination: {
          total: parseInt(productListResponse?.total),
          lastPage: parseInt(productListResponse?.last_page),
          perPage: parseInt(productListResponse?.per_page),
          currentPage: parseInt(productListResponse?.current_page),
        },
      },
    });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'در گرفتن اطلاعات سبد خرید شما مشکلی پیش آمده است، لطفا مجددا تلاش کنید.',
      severity: 'danger',
    });
  }
}

function* productsMiddleware() {
  yield all([
    takeLatest(ProductsActionTypes.GET_PRODUCT_LIST, getProductsListWatcher),
  ]);
}

export default productsMiddleware;
